
import styles from "./StatusBox.module.scss";

export type ColorType = "success" | "error" | "warning" | "info"; 
export type variant = "rounded" | "square";

export interface StatusBoxProps {
  label?: string;
  size?: {
    width?: string;
    height?: string;
    font?: string;
  };
  color?: {
    background?: string;
    text?: string;
  };
  children?: React.ReactNode;
  colorType?:ColorType 
  variant?: variant
}

/**
 * Status Box Label
 * @param param0
 * @returns
 */
export default function StatusBox({
  children,
  label,
  color,
  colorType,
  size,
  variant = "rounded"
}: StatusBoxProps) {

  const styleColor =  color ? 
  ({
    color: color?.text,
    backgroundColor: color?.background,
  }) :  getColorStyle(colorType)


  return (
    <div
      style={{

        fontSize: size?.font,
        width: size?.width || "auto",
        height: size?.height || "20px",
        ...styleColor,
      }}
      className={[styles["statusBox-container"], styles["statusBox-container--"+variant]].join(" ")}
    >
      <p className={styles["statusBox-container__label"]} style={{fontSize: size?.font}}>
        {label && label}
        {children}
      </p>
    </div>
  );
}

const getColorStyle = (colorType: StatusBoxProps["colorType"]) => {
  switch (colorType) {
    case "success":
      return {
        backgroundColor: "#f0f9eb",
        color: "green",
      };
    case "error":
      return {
        backgroundColor: "#fef0f0",
        color: "#f56c6c",
      };
    case "warning":
      return {
        backgroundColor: "#fdf6ec",
        color: "#e6a23c",
      };
    case "info":
      return {
        backgroundColor: "#f4f4f5",
        color: "#909399",
      };
    default:
      return {};
  }
};
